import { useState, useEffect } from "react";
import useApi from "./useApi";

const MANAGED_REPS_CACHE_TTL_MS = 60000;
const managedRepsCache = new Map();

const useSupervisorReps = (supervisorId = null) => {
  const [reps, setReps] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const { postData } = useApi();

  useEffect(() => {
    const fetchReps = async () => {
      const cacheKey = supervisorId || "__all__";
      const cached = managedRepsCache.get(cacheKey);

      if (
        cached &&
        Array.isArray(cached.data) &&
        Date.now() - cached.at < MANAGED_REPS_CACHE_TTL_MS
      ) {
        setReps(cached.data);
        setIsLoading(false);
        return;
      }

      try {
        const action = supervisorId ? "getManagedReps" : "getRepOptions";
        const result = await postData({
          entityName: "User",
          action,
          data: supervisorId ? { supervisorId } : {},
        });

        if (result?.isSuccessful) {
          const repsData = result.data || [];
          managedRepsCache.set(cacheKey, {
            data: repsData,
            at: Date.now(),
          });
          setReps(repsData);
        } else {
          setReps([]);
        }
      } catch (error) {
        console.error("Error fetching managed reps:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchReps();
  }, [supervisorId]); // Re-fetch when supervisorId changes

  return { reps, isLoading };
};

export default useSupervisorReps;
